import { Component, Input, OnDestroy, Type, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavigationService } from '@ubie/core';
import { Subject, takeUntil } from 'rxjs';
import { ModalDismissType } from '../../enums/modal-dismiss-type.enum';

@Component({
  selector: 'shared-plain-modal-with-close-icon',
  templateUrl: './plain-modal-with-close-icon.component.html',
  styleUrl: './plain-modal-with-close-icon.component.scss',
  standalone: false,
})
export class PlainModalWithCloseIconComponent implements OnDestroy {
  private readonly modalController = inject(ModalController);
  private readonly navigationService = inject(NavigationService);

  private readonly destroy$ = new Subject<void>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() dismissOnSelect = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() component: Type<any> | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() componentInputs?: any;

  constructor() {
    this.closeModalOnNavigation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.modalController.dismiss(null, ModalDismissType.Close);
  }

  onContentClick(): void {
    if (this.dismissOnSelect) {
      this.modalController.dismiss(null, ModalDismissType.Close);
    }
  }

  private closeModalOnNavigation(): void {
    this.navigationService.navigationCalled$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.modalController.dismiss(null, ModalDismissType.Close);
      });
  }
}
